<div bsModal #createOrEditModal="bs-modal" style="z-index: 1050;" class="modal fade approve-modal" tabindex="-1" role="dialog" aria-labelledby="createOrEditModal" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #workFlowItemForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span>{{l("Approve")}} {{title}}</span>
                    </h4>                    
                    
                    
                 <button type="button" class="btn-close" (click)="close()" aria-label="Close" [disabled]="saving"></button>
             
                </div>
                <div class="modal-body">
                 

                    <div class="my-3">
                        <label class="form-label" for="WorkFlowItem_Approve_Description"><b>{{l("AreYouSureToApprove")}} {{title}}?</b></label>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="WorkFlowItem_Approve_Description">{{l("Opinion")}}</label>
                        <input type="text" #WorkFlowItem_Approve_Description="ngModel" id="WorkFlowItem_Approve_Description" class="form-control" [(ngModel)]="description" name="WorkFlowItem_Approve_Description"/>
                        <validation-messages [formCtrl]="WorkFlowItem_Approve_Description"></validation-messages>
                    </div>
					
					
					

                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">{{l("Cancel")}}</button>
                    <button type="submit" class="btn btn-success blue" [disabled]="!workFlowItemForm.form.valid" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"><i class="fa fa-paper-plane"></i> <span>{{l("Approve")}}</span></button>
                </div>
            </form>
        </div>
    </div>

</div>